<div class="scope-store-panel" data-id="authorityScopeStorePanel">
  <div class="panel-head">
    <span class="panel-title" data-id="scopeStorePanelTitle">Stores under {{ scopeName() }}</span>
    <a aria-label="Close" class="panel-close" data-id="scopeStorePanelClose" (click)="closed.emit()">
      <em class="icon-close"></em>
    </a>
  </div>

  <div class="panel-body" [class.expanded]="expanded()">
    <span class="store-item" *ngFor="let store of visibleStores(); index as i" [attr.data-id]="'scopeStore' + i">
      {{ store.code }} {{ store.name }}
    </span>
  </div>

  <span class="panel-empty" *ngIf="!stores().length" data-id="scopeStorePanelEmpty">No Data</span>

  <a *ngIf="canExpand()" class="btn-text-link panel-toggle" data-id="scopeStorePanelToggle" (click)="toggleExpand()">
    {{ expanded() ? 'View less' : 'View more' }}
  </a>
</div>
